import Utility from "./utility";
import amplitude from "amplitude-js";
import {
  ampUserProperties,
  getAmplitudeInstance,
} from "../config/amplitudeKeys";
import { keyMapsGetter } from "./storeKeys";
import store from "../store/index";
import {
  VWO_HOMEPAGE_EXPERIMENT,
  VWO_VARIANT_HOMEPAGE_HEADER_NAME,
  VWO_EXPERIMENT_VARIANTS,
} from "../config/vwoKeys";
import PageNames from "../config/pageNames";
import LocalStorageFunc from "./localStorageFunc";
import StorageKeys from "../config/storageKeys";
import { OrderTypesCode } from "../helpers/orderTypesConstants";

const setEvents = (eventDestination, name, eventProperties) => {
  if (eventDestination == "amplitude") {
    loadAmplitudeEvents(name, eventProperties);
  } else if (eventDestination == "moengage") {
    loadMoengageEvents(name, eventProperties);
  } else if (eventDestination == "ga") {
    loadGaEvents(name, eventProperties);
  } else if (eventDestination == "meta") {
    loadMetaEvents(name, eventProperties);
  }
};

const loadMoengageEvents = (event, eventProperties) => {
  if (window.Moengage !== undefined) {
    window.Moengage.track_event(event, eventProperties);
  }
};

const loadGaEvents = (event, eventProperties) => {
  /*   dataLayer.push({
    event: event,
    ...eventProperties,
  }); */
  //console.log("event", event, eventProperties);
  gtag("event", event, eventProperties);
};

const loadMetaEvents = (event, eventProperties) => {
  eventProperties = updateEventPropsBasedOnVwoVariant(eventProperties);
  eventProperties.Events_time_stamp = new Date().getTime(); //timeStamp in every event

  if (
    Object.keys(store.getters[keyMapsGetter.GET_VWO_EXPERIMENTS])?.length &&
    window.metaEventsTemp?.length == 0 &&
    typeof window?.fbq === "function"
  ) {
    window.fbq("track", event);
  } else {
    if (!window.metaEventsTemp) {
      window.metaEventsTemp = [];
    }
    window.metaEventsTemp.push({
      event: event,
      eventProperties: eventProperties,
    });
  }
};

const loadAmplitudeEvents = (event, eventProperties) => {
  eventProperties = updateEventPropsBasedOnVwoVariant(eventProperties);
  eventProperties.Events_time_stamp = new Date().getTime(); //timeStamp in every event

  if (
    Object.keys(store.getters[keyMapsGetter.GET_VWO_EXPERIMENTS])?.length &&
    window.amplitudeEventsTemp?.length == 0
  ) {
    getAmplitudeInstance().logEvent(event, eventProperties);
  } else {
    if (!window.amplitudeEventsTemp) {
      window.amplitudeEventsTemp = [];
    }
    window.amplitudeEventsTemp.push({
      event: event,
      eventProperties: eventProperties,
    });
  }
};

const initializeTimeSpentEvent = async (param) => {
  try {
    let timeOut = 0;
    const amplitudeAppLaunchEventFireTime = window?._siteProps_?.props
      ?.amplitudeAppLaunchEventFireTime
      ? window?._siteProps_?.props?.amplitudeAppLaunchEventFireTime
      : "3";
    if (timeOut) {
      clearTimeout(timeOut);
    }
    timeOut = setTimeout(() => {
      setEvents("amplitude", "time_spent", {
        eventCategory: "time spent",
        fired_after: amplitudeAppLaunchEventFireTime,
        Events_time_stamp: new Date().getTime(),
        Page_Name: param,
      });
    }, amplitudeAppLaunchEventFireTime * 1000);
  } catch (error) {
    console.log("ERROR: COULD NOT Call Amplitude Time Spent Event", error);
  }
};

const loadAmplitudeUnsentEvents = (param) => {
  initializeTimeSpentEvent(param);
  getAmplitudeInstance().setUserProperties({
    ...(ampUserProperties() || {}),
    [VWO_VARIANT_HOMEPAGE_HEADER_NAME]:
      Utility.tryJsonParse(sessionStorage.VWO_VARIATIONS)?.[
        VWO_HOMEPAGE_EXPERIMENT
      ] || "N/A",
  });

  window.amplitudeEventsTemp?.forEach((amplitudeEventTemp) => {
    getAmplitudeInstance().logEvent(
      amplitudeEventTemp.event,
      amplitudeEventTemp.eventProperties
    );
  });
  window.amplitudeEventsTemp = [];
};

const updateAmplitudeUserProperties = (properties = {}) => {
  getAmplitudeInstance().setUserProperties(properties);
};

const updateEventPropsBasedOnVwoVariant = (eventProperties) => {
  let exp = store.getters[keyMapsGetter.GET_VWO_EXPERIMENTS];
  if (exp?.[VWO_HOMEPAGE_EXPERIMENT] === VWO_EXPERIMENT_VARIANTS.VARIANT_A) {
    //eventProperties.Page_Name === "hongs home page";
  }
  return eventProperties;
};

const getAmplitudeEventObj = (eObj) => {
  return {
    ...(eObj.userAction && {
      userAction: eObj.userAction,
    }),
    ...(eObj.sectionName && {
      sectionName: eObj.sectionName,
    }),
    ...(eObj.sectionPosition && {
      sectionPosition: eObj.sectionPosition,
    }),
    ...(eObj.positionWithinSection && {
      positionWithinSection: eObj.positionWithinSection,
    }),
    ...(eObj.category && { category: eObj.category }),
    ...(eObj.subCategory && { subCategory: eObj.subCategory }),
    ...(eObj.categoryPosition && {
      categoryPosition: eObj.categoryPosition,
    }),
    ...(eObj.cartValue && {
      cartValue: eObj.cartValue,
    }),
    ...(eObj.discountAmount && {
      discountAmount: eObj.discountAmount,
    }),
    ...(eObj.itemName && {
      itemName: eObj.itemName,
    }),
    ...(eObj.itemSku && {
      itemSku: eObj.itemSku,
    }),
    ...(eObj.quantity && {
      quantity: eObj.quantity,
    }),
    ...(eObj.price && {
      price: eObj.price,
    }),
    ...(eObj.totalCartAmount && {
      totalCartAmount: eObj.totalCartAmount,
    }),
    ...(eObj.totalCartQuantity && {
      totalCartQuantity: eObj.totalCartQuantity,
    }),
    ...(eObj.subTotal && {
      subTotal: eObj.subTotal,
    }),
    ...(eObj.totalQuantity && {
      totalQuantity: eObj.totalQuantity,
    }),
    ...(eObj.cartId && {
      cartId: eObj.cartId,
    }),
    ...(eObj.orderId && {
      orderId: eObj.orderId,
    }),
    ...(eObj.paymentSummary && {
      paymentSummary: eObj.paymentSummary,
    }),
    ...(eObj.deliveryOrderTypeSummary && {
      deliveryOrderTypeSummary: eObj.deliveryOrderTypeSummary,
    }),
    ...(eObj.invalidItemsInCart && {
      invalidItemsInCart: eObj.invalidItemsInCart,
    }),
    ...(eObj.invalidItemsName && {
      invalidItemsName: eObj.invalidItemsName,
    }),
    ...(eObj.isComboCart && {
      isComboCart: eObj.isComboCart,
    }),
    ...(eObj.isVegCart && {
      isVegCart: eObj.isVegCart,
    }),
    ...(eObj.paymentMethodSaved && {
      paymentMethodSaved: eObj.paymentMethodSaved,
    }),
    ...(eObj.paymentMethod && {
      paymentMethod: eObj.paymentMethod,
    }),
    ...(eObj.addressSaved && {
      addressSaved: eObj.addressSaved,
    }),
    ...(eObj.couponStatus && {
      couponStatus: eObj.couponStatus,
    }),
    ...(eObj.deliveryType && {
      deliveryType: eObj.deliveryType,
    }),
    ...(eObj.itemSKU && {
      itemSKU: eObj.itemSKU,
    }),
    ...(eObj.addCounter && {
      addCounter: eObj.addCounter,
    }),
    ...(eObj.isVegItem && {
      isVegItem: eObj.isVegItem,
    }),
    ...(eObj.itemOriginalPrice && {
      itemOriginalPrice: eObj.itemOriginalPrice,
    }),
    ...(eObj.itemPosition && {
      itemPosition: eObj.itemPosition,
    }),
    ...(eObj.itemCategory && {
      itemCategory: eObj.itemCategory,
    }),
    ...(eObj.isCustomizedItem && {
      isCustomizedItem: eObj.isCustomizedItem,
    }),
    ...(eObj.freeItem && {
      freeItem: eObj.freeItem,
    }),
    ...(eObj.freeItemCategory && {
      freeItemCategory: eObj.freeItemCategory,
    }),
    ...(eObj.lastCartItem && {
      lastCartItem: eObj.lastCartItem,
    }),
    ...(eObj.noOfItemsAvailable && {
      noOfItemsAvailable: eObj.noOfItemsAvailable,
    }),
    ...(eObj.noOfCategoriessAvailable && {
      noOfCategoriessAvailable: eObj.noOfCategoriessAvailable,
    }),
    ...(eObj.itemsCountInCategory && {
      itemsCountInCategory: eObj.itemsCountInCategory,
    }),
    ...(eObj.effective_grand_total && {
      effective_grand_total: eObj.effective_grand_total,
    }),
    ...(eObj.grand_total && {
      grand_total: eObj.grand_total,
    }),
    ...(eObj.strike_grand_total && {
      strike_grand_total: eObj.strike_grand_total,
    }),
    ...(eObj.sub_total && {
      sub_total: eObj.sub_total,
    }),
    ...(eObj.total_tax && {
      total_tax: eObj.total_tax,
    }),
    ...(eObj.eventCategory && {
      eventCategory: eObj.eventCategory,
    }),
    ...(eObj.locationPermission && {
      locationPermission: eObj.locationPermission,
    }),
    ...(eObj.addressAvailability && {
      addressAvailability: eObj.addressAvailability,
    }),
    ...(eObj.addressStatus && {
      addressStatus: eObj.addressStatus,
    }),
    ...(eObj.OrderType && {
      OrderType: eObj.OrderType,
    }),
    ...(eObj.deliveryETA && {
      deliveryETA: eObj.deliveryETA,
    }),
    ...(eObj.deliveryGuarantee && {
      deliveryGuarantee: eObj.deliveryGuarantee,
    }),
    ...(eObj.savings && {
      savings: eObj.savings,
    }),
    ...(eObj.comboApplied && {
      comboApplied: eObj.comboApplied,
    }),
    ...(eObj.searchTerm && {
      searchTerm: eObj.searchTerm,
    }),
    ...(eObj.eventAction && {
      eventAction: eObj.eventAction,
    }),
    ...(eObj.eventLabel && {
      eventLabel: eObj.eventLabel,
    }),
    ...(eObj.tipValue && {
      tipValue: eObj.tipValue,
    }),
    ...(eObj.subcategory && {
      subcategory: eObj.subcategory,
    }),
    ...(eObj.orderType && {
      orderType: eObj.orderType,
    }),
    ...(eObj.orderStatus && {
      orderStatus: eObj.orderStatus,
    }),
    ...(eObj.checkoutOption && {
      checkoutOption: eObj.checkoutOption,
    }),
    ...(eObj.checkoutStep && {
      checkoutStep: eObj.checkoutStep,
    }),
    ...(eObj.checkoutStage && {
      checkoutStage: eObj.checkoutStage,
    }),
    ...(eObj.address && {
      address: eObj.address,
    }),
    screenName: eObj.screenName
      ? eObj.screenName
      : LocalStorageFunc.getSessionStorageKey(
          StorageKeys.SCREEN_NAME,
          PageNames.HONGS_HOME_PAGE
        ),
    Page_Name: eObj.screenName
      ? eObj.screenName
      : LocalStorageFunc.getSessionStorageKey(
          StorageKeys.SCREEN_NAME,
          PageNames.HONGS_HOME_PAGE
        ),
    previousScreenname: eObj.previousScreenname
      ? eObj.previousScreenname
      : LocalStorageFunc.getSessionStorageKey(
          StorageKeys.PREVIOUS_SCREEN_NAME,
          document.referrer
        ),
  };
};

const getGaEventObj = (eObj) => {
  return {
    ...(eObj.ecommerce && {
      ecommerce: JSON.stringify(eObj.ecommerce),
    }),
    ...(eObj.loginMethod && {
      loginMethod: eObj.loginMethod,
    }),
    ...(eObj.eventCategory && {
      eventCategory: eObj.eventCategory,
    }),
    ...(eObj.eventAction && {
      eventAction: eObj.eventAction,
    }),
    ...(eObj.eventLabel && {
      eventLabel: eObj.eventLabel,
    }),
    ...(eObj.couponCode && {
      couponCode: eObj.couponCode,
    }),
    ...(eObj.couponIndex && {
      couponIndex: eObj.couponIndex,
    }),
    ...(eObj.upsellProductName && {
      upsellProductName: eObj.upsellProductName,
    }),
    ...(eObj.productName && {
      productName: eObj.productName,
    }),
    ...(eObj.customizationOption && {
      customizationOption: eObj.customizationOption,
    }),
    ...(ampUserProperties() || {}),
    pageName: eObj.screenName
      ? eObj.screenName
      : LocalStorageFunc.getSessionStorageKey(
          StorageKeys.SCREEN_NAME,
          PageNames.HONGS_HOME_PAGE
        ),
    userStatus: LocalStorageFunc.isLoggedIn(),
  };
};

const getGaEcommerceValueOneItem = () => {
  const lp = store.state.Cart.lastInteractedProductCard;
  const parentCategory =
    store.state.ProductItems.productCategoryMapShort[
      store.state.ProductItems.productCategoryToParentCategoryMap[
        lp.categoryId
      ] || ""
    ] || "";
  return {
    items: [
      {
        item_id: lp.productId,
        item_name: lp.productName,
        affiliation: "Hong's Kitchen PWA",
        coupon: "",
        currency: "INR",
        discount: "",
        index: lp.index,
        item_brand: "",
        item_category:
          parentCategory ||
          store.state.ProductItems.productCategoryMapShort[lp.categoryId],
        item_category2: parentCategory
          ? store.state.ProductItems.productCategoryMapShort[lp.categoryId] ||
            ""
          : "",
        item_category3: lp.selectedVariant,
        item_category4: "",
        item_category5: "",
        item_list_id: LocalStorageFunc.getSessionStorageKey(
          StorageKeys.SCREEN_NAME,
          PageNames.HONGS_HOME_PAGE
        ),
        item_list_name: LocalStorageFunc.getSessionStorageKey(
          StorageKeys.SCREEN_NAME,
          PageNames.HONGS_HOME_PAGE
        ),
        item_variant: lp.selectedVariant,
        location_id: LocalStorageFunc.storeId(),
        price: lp.currentPrice,
        quantity: 1,
      },
    ],
  };
};

const getGaEcommerceValueForAllItem = () => {
  const cItemIterator = store.state.Cart.cartItemsListingPageIterator;

  return {
    items: Object.keys(cItemIterator).map((itemId, index) => {
      return {
        item_id: itemId,
        item_name: cItemIterator[itemId].displayName,
        affiliation: "Hong's Kitchen PWA",
        coupon: "",
        currency: "INR",
        discount: "",
        index,
        item_brand: "",
        item_category: "",
        item_category2: "",
        item_category3:
          cItemIterator[itemId]?.selectedVariant?.displayName || "",
        item_category4: "",
        item_category5: "",
        item_list_id: LocalStorageFunc.getSessionStorageKey(
          StorageKeys.SCREEN_NAME,
          PageNames.HONGS_HOME_PAGE
        ),
        item_list_name: LocalStorageFunc.getSessionStorageKey(
          StorageKeys.SCREEN_NAME,
          PageNames.HONGS_HOME_PAGE
        ),
        item_variant: cItemIterator[itemId]?.selectedVariant?.displayName || "",
        location_id: LocalStorageFunc.storeId(),
        price: Utility.getProductCurrentPrice(cItemIterator[itemId]),
        quantity: cItemIterator[itemId].quantity, // todo : check and implement accordingly
      };
    }),
  };
};

const updateScreenPreviousScreen = (screenNameShouldBe) => {
  let screenNameFromStorage = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.SCREEN_NAME,
    ""
  );
  if (screenNameFromStorage != screenNameShouldBe) {
    updateAmplitudeUserProperties({
      screenName: screenNameShouldBe,
      previousScreenname: screenNameFromStorage,
    });
    LocalStorageFunc.setSessionStorageKey(
      StorageKeys.PREVIOUS_SCREEN_NAME,
      screenNameFromStorage
    );
    LocalStorageFunc.setSessionStorageKey(
      StorageKeys.SCREEN_NAME,
      screenNameShouldBe
    );
  }
};

const EVENT_PAGEVIEW_HOMEPAGE = (eObj = {}) => {
  eObj["screenName"] = PageNames.HONGS_HOME_PAGE;

  updateScreenPreviousScreen(PageNames.HONGS_HOME_PAGE);

  eObj["previousScreenname"] = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.PREVIOUS_SCREEN_NAME,
    ""
  );

  setEvents("amplitude", "pageView", getAmplitudeEventObj(eObj));
  setEvents("ga", "page_view", getGaEventObj(eObj));
  setEvents("meta", "FB_PageView", {});
};

const EVENT_PAGEVIEW_SEARCHPAGE = (eObj = {}) => {
  eObj["screenName"] = PageNames.HONGS_SEARCH_PAGE;

  updateScreenPreviousScreen(PageNames.HONGS_SEARCH_PAGE);

  eObj["previousScreenname"] = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.PREVIOUS_SCREEN_NAME,
    ""
  );

  setEvents("amplitude", "pageView", getAmplitudeEventObj(eObj));
  setEvents("ga", "page_view", getGaEventObj(eObj));
  setEvents("meta", "FB_PageView", {});
};

const EVENT_PAGEVIEW_OFFERSPAGE = (eObj = {}) => {
  eObj["screenName"] = PageNames.HONGS_OFFERS_PAGE;

  updateScreenPreviousScreen(PageNames.HONGS_OFFERS_PAGE);

  eObj["previousScreenname"] = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.PREVIOUS_SCREEN_NAME,
    ""
  );

  setEvents("amplitude", "pageView", getAmplitudeEventObj(eObj));
  setEvents("ga", "page_view", getGaEventObj(eObj));
  setEvents("meta", "FB_PageView", {});
};

const EVENT_PAGEVIEW_MENUPAGE = (eObj = {}) => {
  eObj["screenName"] = PageNames.HONGS_MENU_PAGE;

  updateScreenPreviousScreen(PageNames.HONGS_MENU_PAGE);

  eObj["previousScreenname"] = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.PREVIOUS_SCREEN_NAME,
    ""
  );

  setEvents("amplitude", "pageView", getAmplitudeEventObj(eObj));
  setEvents("ga", "page_view", getGaEventObj(eObj));
  setEvents("meta", "FB_PageView", {});
};

const EVENT_PAGEVIEW_PROFILEPAGE = (eObj = {}) => {
  eObj["screenName"] = PageNames.HONGS_PROFILE_PAGE;

  updateScreenPreviousScreen(PageNames.HONGS_PROFILE_PAGE);

  eObj["previousScreenname"] = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.PREVIOUS_SCREEN_NAME,
    ""
  );

  setEvents("amplitude", "pageView", getAmplitudeEventObj(eObj));
  setEvents("ga", "page_view", getGaEventObj(eObj));
  setEvents("meta", "FB_PageView", {});
};

const EVENT_PAGEVIEW_ORDERHISTORYPAGE = (eObj = {}) => {
  eObj["screenName"] = PageNames.HONGS_ORDERHISTORY_PAGE;

  updateScreenPreviousScreen(PageNames.HONGS_ORDERHISTORY_PAGE);

  eObj["previousScreenname"] = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.PREVIOUS_SCREEN_NAME,
    ""
  );

  setEvents("amplitude", "pageView", getAmplitudeEventObj(eObj));
  setEvents("ga", "page_view", getGaEventObj(eObj));
  setEvents("meta", "FB_PageView", {});
};

const EVENT_PAGEVIEW_ADDRESSESPAGE = (eObj = {}) => {
  eObj["screenName"] = PageNames.HONGS_ADDRESSES_PAGE;

  updateScreenPreviousScreen(PageNames.HONGS_ADDRESSES_PAGE);

  eObj["previousScreenname"] = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.PREVIOUS_SCREEN_NAME,
    ""
  );

  setEvents("amplitude", "pageView", getAmplitudeEventObj(eObj));
  setEvents("ga", "page_view", getGaEventObj(eObj));
  setEvents("meta", "FB_PageView", {});
};

const EVENT_PAGEVIEW_FAVOURITEPAGE = (eObj = {}) => {
  eObj["screenName"] = PageNames.HONGS_FAVOURITE_PAGE;

  updateScreenPreviousScreen(PageNames.HONGS_FAVOURITE_PAGE);

  eObj["previousScreenname"] = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.PREVIOUS_SCREEN_NAME,
    ""
  );

  setEvents("amplitude", "pageView", getAmplitudeEventObj(eObj));
  setEvents("ga", "page_view", getGaEventObj(eObj));
  setEvents("meta", "FB_PageView", {});
};

const EVENT_PAGEVIEW_LOGINPAGE = (eObj = {}) => {
  eObj["screenName"] = PageNames.HONGS_LOGIN_PAGE;

  updateScreenPreviousScreen(PageNames.HONGS_LOGIN_PAGE);

  eObj["previousScreenname"] = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.PREVIOUS_SCREEN_NAME,
    ""
  );

  setEvents("amplitude", "pageView", getAmplitudeEventObj(eObj));
  setEvents("ga", "page_view", getGaEventObj(eObj));
  setEvents("meta", "FB_PageView", {});
};

const EVENT_PAGEVIEW_CARTPAGE = (eObj = {}) => {
  eObj["screenName"] = PageNames.HONGS_CART_PAGE;

  updateScreenPreviousScreen(PageNames.HONGS_CART_PAGE);

  eObj["previousScreenname"] = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.PREVIOUS_SCREEN_NAME,
    ""
  );

  setEvents("amplitude", "pageView", getAmplitudeEventObj(eObj));
  setEvents("ga", "page_view", getGaEventObj(eObj));
  setEvents("meta", "FB_PageView", {});
};

const EVENT_PAGEVIEW_LOCATIONPAGE = (eObj = {}) => {
  eObj["screenName"] = PageNames.HONGS_LOCATION_PAGE;

  updateScreenPreviousScreen(PageNames.HONGS_LOCATION_PAGE);

  eObj["previousScreenname"] = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.PREVIOUS_SCREEN_NAME,
    ""
  );

  setEvents("amplitude", "pageView", getAmplitudeEventObj(eObj));
  setEvents("ga", "page_view", getGaEventObj(eObj));
  setEvents("meta", "FB_PageView", {});
};

const EVENT_PAGEVIEW_CONTENTPAGE = (eObj = {}) => {
  let currentPageName = PageNames.getPageNameFromPathName()
  eObj["screenName"] = currentPageName;

  updateScreenPreviousScreen(currentPageName);

  eObj["previousScreenname"] = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.PREVIOUS_SCREEN_NAME,
    ""
  );

  setEvents("amplitude", "pageView", getAmplitudeEventObj(eObj));
  setEvents("ga", "page_view", getGaEventObj(eObj));
  setEvents("meta", "FB_PageView", {});
};
const EVENT_CLICK_SEARCHICON = (eObj = {}) => {
  eObj["category"] = "opened";
  eObj["userAction"] = "click";
  eObj["sectionName"] = "search";
  eObj["sectionPosition"] = "1";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "search_click", getGaEventObj(eObj));
};

const EVENT_TYPE_SEARCHINPUT = (eObj = {}) => {
  eObj["sectionName"] = "search";
  eObj["sectionPosition"] = "1";

  setEvents("amplitude", "search_field_interacted", getAmplitudeEventObj(eObj));
  setEvents("ga", "search_field_interacted", getGaEventObj(eObj));
};

const EVENT_IMPRESSION_SEARCHRESULT = (eObj = {}) => {
  eObj["userAction"] = "impression";
  eObj["sectionName"] = "search";
  eObj["sectionPosition"] = "1";

  setEvents("amplitude", "search_value_shown", getAmplitudeEventObj(eObj));
  setEvents("ga", "search_value_shown", getGaEventObj(eObj));
};

const EVENT_IMPRESSION_PROMOTION = (eObj = {}) => {
  eObj["userAction"] = "impression";
  eObj["sectionName"] = "promotion";
  eObj["sectionPosition"] = "3";

  //setEvents("amplitude", "Impression", getAmplitudeEventObj(eObj));
  setEvents("ga", "view_promotion", getGaEventObj(eObj));
};

const EVENT_CLICK_SEARCHOPTION = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "search";
  eObj["sectionPosition"] = "1";

  setEvents("amplitude", "search_option_selected", getAmplitudeEventObj(eObj));
  setEvents("ga", "search_option_selected", getGaEventObj(eObj));
};

const EVENT_CLICK_PROMOTION = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "promotion";
  eObj["sectionPosition"] = "3";

  //setEvents("amplitude", "select_promotion", getAmplitudeEventObj(eObj));
  setEvents("ga", "select_promotion", getGaEventObj(eObj));
};

const EVENT_IMPRESSION_OFFERS = (eObj = {}) => {
  eObj["userAction"] = "impression";
  eObj["category"] = "ecommerce";
  eObj["subCategory"] = "promotion impression";

  setEvents("amplitude", "Impression", getAmplitudeEventObj(eObj));
};

const EVENT_CLICK_ORDERTYPE = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "order type toggle";
  eObj["sectionPosition"] = "3";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  switch (eObj["orderType"]) {
    case OrderTypesCode.DELIVERY_CODE:
      setEvents("ga", "delivery_mode_selected", getGaEventObj(eObj));
      break;
    case OrderTypesCode.TAKEAWAY_CODE:
      setEvents("ga", "takeaway_mode_selected", getGaEventObj(eObj));
      break;
    case OrderTypesCode.DINE_IN_CODE:
      setEvents("ga", "dinein_mode_selected", getGaEventObj(eObj));
      break;
  }
};

const EVENT_IMPRESSION_INLINENOTIFICATION = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "Notification Message";
  eObj["sectionPosition"] = "2";
  eObj["positionWithinSection"] = "1";
  eObj["category"] = "Notification Message";

  setEvents("amplitude", "impression", getAmplitudeEventObj(eObj));
  setEvents("ga", "inline_notification_visible", getGaEventObj(eObj));
};

const EVENT_CLICK_INLINENOTIFICATION = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "inline notification";
  eObj["sectionPosition"] = "2";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "inline_notification_interacted", getGaEventObj(eObj));
};

const EVENT_IMPRESSION_UPSELL_ITEM = (eObj = {}) => {
  eObj["userAction"] = "impression";
  eObj["sectionName"] = "upsell";
  eObj["sectionPosition"] = "1";

  setEvents("ga", "upsell_item_impression", getGaEventObj(eObj));
};

const EVENT_CLICK_UPSELL_ITEM = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "upsell";
  eObj["sectionPosition"] = "1";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "upsell_item_selected", getGaEventObj(eObj));
};

const EVENT_CLICK_FILTERS = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "home page menu";
  eObj["sectionPosition"] = "6";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  switch (eObj["category"]) {
    case "Veg":
      setEvents("ga", "veg_filter_clicked", getGaEventObj(eObj));
      break;
    case "Non-Veg":
      setEvents("ga", "non_veg_filter_clicked", getGaEventObj(eObj));
      break;
  }
};

const EVENT_CLICK_MENU_CATEGORY = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "menu category";
  eObj["sectionPosition"] = "3";
  eObj["category"] = "menu category";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "upsell_item_selected", getGaEventObj(eObj));
};

const EVENT_CLICK_BOTTOM_STICKY_BAR = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "Bottom Sticky Menu";
  eObj["sectionPosition"] = "3";
  eObj["category"] = "Bottom Sticky Menu Clicked";

  setEvents(
    "amplitude",
    "bottom_sticky_menu_clicked",
    getAmplitudeEventObj(eObj)
  );
  setEvents("ga", "upsell_item_selected", getGaEventObj(eObj));
};

const EVENT_CLICK_FAVOURITE_BUTTON = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "favourite";

  setEvents("ga", "favourite_button_clicked", getGaEventObj(eObj));
};
const EVENT_CLICK_ADDRESS = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "address selection";
  eObj["sectionPosition"] = "1";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "change_address_clicked", getGaEventObj(eObj));
};

const EVENT_CLICK_ADDTOCART = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "add to cart";
  eObj["sectionPosition"] = "8"; //cartId
  eObj["category"] = "ecommerce";
  eObj["subCategory"] = "add to cart";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));

  eObj["ecommerce"] = getGaEcommerceValueOneItem();
  setEvents("ga", "add_to_cart", getGaEventObj(eObj));
  setEvents("meta", "FB_AddToCart", {});
};

const EVENT_CLICK_REMOVEFROMCART = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "remove from cart";
  eObj["sectionPosition"] = "8"; //cartId
  eObj["category"] = "ecommerce";
  eObj["subCategory"] = "remove from cart";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));

  eObj["ecommerce"] = getGaEcommerceValueOneItem();
  setEvents("ga", "remove_from_cart", getGaEventObj(eObj));
  setEvents("meta", "FB_RemoveFromCart", {});
};

const EVENT_CLICK_EDITITEMINCART = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "edit item";
  eObj["sectionPosition"] = "8";
  eObj["category"] = "edit item";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "edit_product_click", getGaEventObj(eObj));
};

const EVENT_CLICK_VIEWCART = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "view cart";
  eObj["sectionPosition"] = "15";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));

  eObj["ecommerce"] = getGaEcommerceValueForAllItem();
  setEvents("ga", "view_cart", getGaEventObj(eObj));
};

const EVENT_HAMBURGER_OPENED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "hamburger";
  eObj["sectionPosition"] = "1";
  eObj["positionWithinSection"] = "3";
  eObj["category"] = "hamburger opened";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "hamburger_opened", getGaEventObj(eObj));
};

const EVENT_IMPRESSION_CUSTOMIZATION = (eObj = {}) => {
  eObj["userAction"] = "impression";
  eObj["sectionName"] = "customization";
  eObj["sectionPosition"] = "1";

  setEvents("ga", "customization_option_visible", getGaEventObj(eObj));
};

const EVENT_CLICK_CUSTOMIZATION = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionPosition"] = "8";
  eObj["category"] = "customization";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
};

const EVENT_CLICK_CUSTOMIZATION_COMBO = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionPosition"] = "8";
  eObj["category"] = "customization";

  setEvents("ga", "customization_option_interacted", getGaEventObj(eObj));
};

const EVENT_TYPE_MOBILENUMBER = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "login";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "phone number";
  eObj["subCategory"] = "input attempted";
  eObj["positionWithinSection"] = "2";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "phone_number_input_attempt", getGaEventObj(eObj));
};

const EVENT_HAMBURGER_CLOSED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "hamburger";
  eObj["sectionPosition"] = "1";
  eObj["positionWithinSection"] = "1";
  eObj["category"] = "hamburger closed";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "hamburger_closed", getGaEventObj(eObj));
};

const EVENT_CLICK_SENDOTP = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "sendOTP";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "send OTP";
  eObj["subCategory"] = "OTP sent";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "send_otp_clicked", getGaEventObj(eObj));
};

const EVENT_HAMBURGER_LIST_ITEM_CLICKED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "hamburger";
  eObj["sectionPosition"] = "2";
  eObj["category"] = "item selected";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  // setEvents(
  //   "ga",
  //   `hamburger_link_clicked - ${eObj["subCategory"]}`,
  //   getGaEventObj(eObj)
  // );
};

const EVENT_LOGIN_CTA_CLICKED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "hamburger";
  eObj["sectionPosition"] = "1";
  eObj["positionWithinSection"] = "2";
  eObj["category"] = "Login";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "hamburger_login_clicked", getGaEventObj(eObj));
};

const EVENT_CLICK_CHANGEMOBILENUMBER = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "login";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "edit mobile";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "change_mobile_click", getGaEventObj(eObj));
};

const EVENT_CLICK_LOGIN_SKIP = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "login";
  eObj["sectionPosition"] = "1";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "login skip";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "skip_login_click", getGaEventObj(eObj));
};

const EVENT_LOGOUT_CTA_CLICKED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "hamburger";
  eObj["sectionPosition"] = "1";
  eObj["positionWithinSection"] = "2";
  eObj["category"] = "Logout";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "hamburger_logout_clicked", getGaEventObj(eObj));
};

const EVENT_CLICK_RESENDSMS = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "login";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "Resend SMS";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "resend_sms_click", getGaEventObj(eObj));
};

const EVENT_CLICK_TRACKORDER = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "My Orders Page";
  eObj["category"] = "Track Order";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "track_button_click", getGaEventObj(eObj));
};

const EVENT_IMPRESSION_TRACKORDER = (eObj = {}) => {
  eObj["userAction"] = "impression";
  eObj["sectionName"] = "trackPage";
  eObj["sectionPosition"] = "1";

  setEvents("amplitude", "Impression", getAmplitudeEventObj(eObj));
};

const EVENT_TYPE_OTP = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "login";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "Enter OTP";

  //setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "otp_entered", getGaEventObj(eObj));
};

const EVENT_CLICK_SUBMITOTP = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "login";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "Submit OTP";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "submit_otp_click", getGaEventObj(eObj));
};

const EVENT_AUTO_LOGIN_TRIGGERED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "login";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "auto-login";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "auto_login", getGaEventObj(eObj));
};

const EVENT_CLICK_AUTO_FETCH_MOBILE_NO = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "login";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "phone number";
  eObj["subcategory"] = "auto-fetch";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "auto_fetch_mobile_no", getGaEventObj(eObj));
};

const EVENT_OTP_GENERATION_SUCCESSFUL = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "sendOTP";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "send OTP";
  eObj["subCategory"] = "OTP success";

  //setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "otp_generation_successful", getGaEventObj(eObj));
};

const EVENT_OTP_GENERATION_FAILED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "sendOTP";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "send OTP";
  eObj["subCategory"] = "OTP failed";

  //setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "otp_generation_failed", getGaEventObj(eObj));
};

const EVENT_LOGIN_SUCCESSFUL = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "login";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "login success";

  //setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "login_successful", getGaEventObj(eObj));
};

const EVENT_LOGIN_FAILED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "login";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "login failed";

  //setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "login_failed", getGaEventObj(eObj));
};

const EVENT_CLICK_HELP_TRACK_ORDER = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "help";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "Help Clicked";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "help_button_click", getGaEventObj(eObj));
};

const EVENT_CLICK_REORDER = (eObj = {}) => {
  eObj["userAction"] = "click";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "reorder_button_click", getGaEventObj(eObj));
};

const EVENT_CLICK_ORDER_DETAIL = (eObj = {}) => {
  eObj["userAction"] = "click";
  (eObj["sectionName"] = "My Orders Page"),
    (eObj["category"] = "Card clicked"),
    (eObj["subcategory"] = "View Detail"),
    setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "order_detail_clicked", getGaEventObj(eObj));
};

const EVENT_CLICK_VIEW_ALL_PREVIOUS_ORDERS = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "reorder";

  setEvents("ga", "viewall_button_previous_order", getGaEventObj(eObj));
};

const EVENT_CLICK_OFFER = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["category"] = "ecommerce";
  eObj["subCategory"] = "promotion click";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "offer_view_more", getGaEventObj(eObj));
};

const EVENT_CLICK_REMOVE_OFFER = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["category"] = "ecommerce";
  eObj["subCategory"] = "coupon removed";

  setEvents("ga", "remove_coupon_clicked", getGaEventObj(eObj));
};

const EVENT_CLICK_OFFER_SELECT = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "offer";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "apply_offer_button_clicked", getGaEventObj(eObj));
};

const EVENT_CLICK_APPLYOFFERSUCCESS = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "offer";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "apply_offer_button_clicked", getGaEventObj(eObj));
};

const EVENT_CLICK_APPLYOFFERFAILURE = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "offer";
  eObj["sectionPosition"] = "4";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "apply_offer_button_clicked", getGaEventObj(eObj));
};

const EVENT_CLICK_OSBACK = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "back button OS";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "back button by OS";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "physical_back_button", getGaEventObj(eObj));
};

const EVENT_CLICK_CALL_TRACK_ORDER = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "call";
  eObj["sectionPosition"] = "3";
  eObj["category"] = "Call";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "call_delivery_partner", getGaEventObj(eObj));
};

const EVENT_CLICK_DOWNLOAD_BILL_TRACK_ORDER = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "download bill";
  eObj["sectionPosition"] = "5";
  eObj["category"] = "Download Bill";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "download_bill", getGaEventObj(eObj));
};

const EVENT_CLICK_VIEW_DETAILED_BILL = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "detailed bill";
  eObj["sectionPosition"] = "5";
  eObj["category"] = "detailed Bill";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "view_detailed_bill", getGaEventObj(eObj));
};

const EVENT_CLICK_PWABACK = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "back button in app";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "back button in app";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "UI_back_button", getGaEventObj(eObj));
};

const EVENT_IMPRESSION_RESTAURANT_SELECTION = (eObj = {}) => {
  eObj["userAction"] = "impression";
  eObj["sectionPosition"] = "1";

  setEvents("amplitude", "Impression", getAmplitudeEventObj(eObj));
};

const EVENT_IMPRESSION_NO_RESTAURANT_AVAILABLE = (eObj = {}) => {
  eObj["userAction"] = "impression";
  eObj["sectionPosition"] = "1";

  setEvents("amplitude", "Impression", getAmplitudeEventObj(eObj));
  setEvents("ga", "no_restaurant_available", getGaEventObj(eObj));
};

const EVENT_IMPRESSION_NO_DELIVERY_ZONE = (eObj = {}) => {
  eObj["userAction"] = "impression";
  eObj["sectionPosition"] = "1";
  eObj["sectionName"] = "address selection";
  eObj["category"] = "address not deliverable";

  setEvents("amplitude", "Impression", getAmplitudeEventObj(eObj));
  setEvents("ga", "no_delivery_zone", getGaEventObj(eObj));
};

const EVENT_CLICK_MAP_OR_LIST_VIEW = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionPosition"] = "2";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  if (eObj["subCategory"] == "map") {
    setEvents("ga", "map_view_option_clicked", getGaEventObj(eObj));
  }
};

const EVENT_CLICK_RESTAURANT_SELECTION = (eObj = {}) => {
  eObj["userAction"] = "click";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "restaurant_selected", getGaEventObj(eObj));
};

const EVENT_CLICK_BOTTOM_STICKY_MENU = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "Bottom sticky - menu";
  eObj["category"] = "opened";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "floating_menu_button_clicked", getGaEventObj(eObj));
};

const EVENT_CLICK_CATEGORY_BOTTOM_STICKY_MENU = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "Bottom sticky - menu";
  eObj["category"] = "category selected";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
};

const EVENT_CLICK_OPTIN_POPUP_ADD_NEW = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "optin popup";
  eObj["category"] = "optin poup add new";

  setEvents("ga", "optin_popup_add_new", getGaEventObj(eObj));
};

const EVENT_CLICK_MINICART_ADD = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "minicart popup";
  eObj["category"] = "minicart poup add";

  //setEvents("ga", "edit_combo_add", getGaEventObj(eObj));
};

const EVENT_CLICK_CARTUPSELL_ADD = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "you may also like";
  eObj["category"] = "add item";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
};

const EVENT_CLICK_MINICART_REMOVE = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "minicart popup";
  eObj["category"] = "minicart poup remove";

  //setEvents("ga", "edit_combo_remove", getGaEventObj(eObj));
};

const EVENT_CLICK_MINICART_UPDATE = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "minicart popup";
  eObj["category"] = "minicart poup update";

  //setEvents("ga", "update_cart_click_edit_combo", getGaEventObj(eObj));
};

const EVENT_CLICK_COMBO_ADD = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "combo";
  eObj["category"] = "combo add";

  setEvents("ga", "edit_combo_add", getGaEventObj(eObj));
};

const EVENT_CLICK_COMBO_REMOVE = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "combo";
  eObj["category"] = "combo remove";

  setEvents("ga", "edit_combo_remove", getGaEventObj(eObj));
};

const EVENT_CLICK_OPTIN_POPUP_REPEAT_LAST = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "optin popup";
  eObj["category"] = "optin poup repeat last";

  setEvents("ga", "optin_popup_repeat_last", getGaEventObj(eObj));
};

const EVENT_IMPRESSION_TIPOPTIONS = (eObj = {}) => {
  eObj["userAction"] = "impression";
  eObj["sectionName"] = "tip delivery partner";

  setEvents("ga", "tipping_delivery_partner_shown", getGaEventObj(eObj));
};

const EVENT_CLICK_TIPOPTIONS_SELECTED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "tip delivery partner";
  eObj["category"] = "tip amount selected";

  eObj["eventType"] = "tip click";

  setEvents("amplitude", "Tip Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "tips_option_selected", getGaEventObj(eObj));
};

const EVENT_CLICK_TIPOTHER_SELECTED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "tip delivery partner";
  eObj["category"] = "tip amount selected - other";

  setEvents("amplitude", "Tip Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "tips_option_selected", getGaEventObj(eObj));
};

const EVENT_CLICK_TIP_UNSELECTED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "tip delivery partner";
  eObj["category"] = "remove";

  eObj["eventType"] = "remove click";

  setEvents("amplitude", "Tip Click", getAmplitudeEventObj(eObj));
};

const EVENT_CLICK_TIPENABLEFORFUTURE = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "tip delivery partner";
  eObj["category"] = "auto tipping selected";
  eObj["eventType"] = "checkbox click";

  setEvents("amplitude", "Tip Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "auto_tip_option_selected", getGaEventObj(eObj));
};

const EVENT_CLICK_TIPDISABLEFORFUTURE = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "tip delivery partner";
  eObj["category"] = "auto tipping removed";
  eObj["eventType"] = "checkbox click";

  setEvents("amplitude", "Tip Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "auto_tip_option_deselected", getGaEventObj(eObj));
};

const EVENT_TIP_ERROR = (eObj = {}) => {
  eObj["eventType"] = "error";
  eObj["sectionName"] = "tip delivery partner";

  setEvents("amplitude", "Tip Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "auto_tip_option_deselected", getGaEventObj(eObj));
};

const EVENT_CLICK_DELIVERYINSTRUCTION = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "delivery instruction";
  eObj["category"] = "delivery instruction";
  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "delivery_instruction_interacted", getGaEventObj(eObj));
};

const EVENT_CLICK_CARTCHANGEADDRESS = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "change address";
  eObj["category"] = "change address";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "change_address_click", getGaEventObj(eObj));
};

const EVENT_NEW_ADDRESS_ADDED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["category"] = "shipping info added";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));

  eObj["ecommerce"] = {
    currency: "INR",
    value: store.getters[keyMapsGetter.CART_TOTAL],
    coupon: LocalStorageFunc.getCouponCode(),
    shipping_tier: LocalStorageFunc.getDeliveryType(),
    ...getGaEcommerceValueForAllItem(),
  };
  setEvents("ga", "add_shipping_info", getGaEventObj(eObj));
};

const EVENT_CLICK_ADVANCE_ORDER_MODAL_OPEN = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "advanced order";
  eObj["category"] = "advance order option interacted";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "advance_order_option_interacted", getGaEventObj(eObj));
};

const EVENT_CLICK_ADVANCE_ORDER_DATE_SELECTED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "advanced order";
  eObj["category"] = "advance order date selected";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "advance_order_date_selected", getGaEventObj(eObj));
};

const EVENT_CLICK_ADVANCE_ORDER_TIME_SELECTED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "advanced order";
  eObj["category"] = "advance order time selected";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "advance_order_time_selected", getGaEventObj(eObj));
};

const EVENT_CLICK_DELIVERYTIME_DROPDOWN = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "advanced order";
  eObj["category"] = "set delivery time";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "delivery_time_dropdown_interacted", getGaEventObj(eObj));
};

const EVENT_CLICK_INSTANT_DELIVERY = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "advanced order";
  eObj["category"] = "instant delivery";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "instant_delivery_selected", getGaEventObj(eObj));
};

const EVENT_CLICK_SCHEDULE_DELIVERY = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "advanced order";
  eObj["category"] = "schedule delivery";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "schedule_delivery_selected", getGaEventObj(eObj));
};

const EVENT_CLICK_ADVANCE_ORDER_FLOW_DONE = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "advanced order";
  eObj["category"] = "set delivery time";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "advance_order_flow_completed", getGaEventObj(eObj));
};

const EVENT_CLICK_ADVANCE_ORDER_TIMEDIFF = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "advanced order";
  eObj["category"] = "set delivery time";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
};

const EVENT_CLICK_VIEWMORECARTOFFERS = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "coupon";
  eObj["category"] = "view more offers";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "view_all_offers", getGaEventObj(eObj));
};

const EVENT_CLICK_VIEWMORE_OFFER_CARD = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "offer";
  eObj["category"] = eObj["couponCode"];
  eObj["subCategory"] = "view more";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "offer_view_more", getGaEventObj(eObj));
};

const EVENT_CLICK_APPLYMANUALCOUPONSUCCESS = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "coupon";
  eObj["subCategory"] = "successful";
  eObj["discountAmount"] = "";
  eObj["cartValue"] = "";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
};

const EVENT_CLICK_APPLYMANUALCOUPONFAILURE = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "coupon";
  eObj["subCategory"] = "failed";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
};

const EVENT_CLICK_CARTSUBMIT = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["category"] = "proceed to pay";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));

  eObj["ecommerce"] = getGaEcommerceValueForAllItem();
  setEvents("ga", "begin_checkout", getGaEventObj(eObj));
};

const EVENT_CLICK_CARTCONTINUE = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["category"] = "continue";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "login_proceed_phone_number", getGaEventObj(eObj));
};

const EVENT_CLICK_CART_EXPLOREMENU = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["category"] = "Explore menu button";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "explore_menu_click", getGaEventObj(eObj));
};

// NG-Cart event

const EVENT_CART_VIEWED = (eObj = {}) => {
  eObj["userAction"] = "View Cart";
  eObj["sectionName"] = "Cart";

  setEvents("amplitude", "Cart Viewed", getAmplitudeEventObj(eObj));
  setEvents("ga", "cart_viewed", getGaEventObj(eObj));
};

const EVENT_CART_END = (eObj = {}) => {
  eObj["userAction"] = "End";
  eObj["sectionName"] = "End of Cart page";
  eObj["category"] = "Cart Page Ended";

  setEvents("amplitude", "Cart End", getAmplitudeEventObj(eObj));
  setEvents("ga", "cart_end", getGaEventObj(eObj));
};

const EVENT_CLICK_ADD_MORE_ITEMS = (eObj = {}) => {
  eObj["userAction"] = "Add More Items";
  eObj["sectionName"] = "Items Added";
  eObj["subSectionName"] = "Add More Items";

  setEvents("amplitude", "Add Items", getAmplitudeEventObj(eObj));
};

const EVENT_CLICK_COUPONS_TOP_BAR = (eObj = {}) => {
  eObj["userAction"] = "Go to Coupon Page";
  eObj["sectionName"] = "Top Bar";
  eObj["state"] = "Active";
  eObj["eventLabel"] = "Percentage Coupons";

  setEvents("amplitude", "coupon", getAmplitudeEventObj(eObj));
};

const EVENT_CART_CLICK_PLUS_ONE = (eObj = {}) => {
  eObj["userAction"] = "Add to Cart Click";
  eObj["sectionName"] = "Items Added";

  setEvents("amplitude", "Cart_Click", getAmplitudeEventObj(eObj));
};

const EVENT_CART_CLICK_MINUS_ONE = (eObj = {}) => {
  eObj["userAction"] = "Remove Item From Cart";
  eObj["sectionName"] = "Items Added";

  setEvents("amplitude", "Cart_Click", getAmplitudeEventObj(eObj));
};

const EVENT_CART_CLICK_REMOVE_LAST_ITEM = (eObj = {}) => {
  eObj["category"] = "Remove Item From Cart";

  setEvents("amplitude", "Cart_Click", getAmplitudeEventObj(eObj));
};

// Cart Upsell Events

const EVENT_CROSS_SELL_CART = (eObj = {}) => {
  eObj["sectionName"] = "CrossSell";

  setEvents("amplitude", "CrossSell", getAmplitudeEventObj(eObj));
};

const EVENT_CART_CLICK_CROSS_SELL_PLUS_ONE = (eObj = {}) => {
  eObj["userAction"] = "Add Item to Cart";
  eObj["sectionName"] = "Cross Sell";

  setEvents("amplitude", "Cart_Click", getAmplitudeEventObj(eObj));
};

const EVENT_CART_CROSS_SELL_COLLAPSE = (eObj = {}) => {
  eObj["userAction"] = "Collapse";
  eObj["sectionName"] = "Cross Sell";

  setEvents("amplitude", "CrossSell", getAmplitudeEventObj(eObj));
};

// CART ADDRESS EVENTS
const EVENT_ADDRESS_STATUS = (eObj = {}) => {
  eObj["userAction"] = "Address Status";
  eObj["subSectionName"] = "Address";

  setEvents("amplitude", "Address Status", getAmplitudeEventObj(eObj));
};

const EVENT_ADD_SELECT_ADDRESS = (eObj = {}) => {
  eObj["userAction"] = "Add New Address";
  eObj["subSectionName"] = "Address";

  setEvents("amplitude", "Add_select_address", getAmplitudeEventObj(eObj));
};

const EVENT_SET_LOCATION_AND_ADD_ADDRESS = (eObj = {}) => {
  eObj["userAction"] = "Set Location & Add Address";
  eObj["eventCategory"] = "Saved Address at cart";

  setEvents(
    "amplitude",
    "set_location_and_Add_Address",
    getAmplitudeEventObj(eObj)
  );
};

// advance order events

const EVENT_ADVANCE_ORDER_CLICK = (eObj = {}) => {
  eObj["sectionName"] = "advanced order";
  setEvents("amplitude", "click", getAmplitudeEventObj(eObj));
};

// cart offer events

const EVENT_CART_COUPON = (eObj = {}) => {
  setEvents("amplitude", "coupon", getAmplitudeEventObj(eObj));
};

const EVENT_APPLY_CLICK_CART_COUPON = (eObj = {}) => {
  eObj["sectionName"] = "Savings & Rewards";
  eObj["eventCategory"] = "Coupon Card";
  eObj["subSectionName"] = "Best Offer on Cart";
  eObj["eventAction"] = "Apply Click";

  setEvents("amplitude", "applyClick", getAmplitudeEventObj(eObj));
};
const EVENT_COUPON_APPLICATION_SUCCESS_CONFETTI_LAUNCHED = (eObj = {}) => {
  eObj["eventCategory"] = "Confetti Launched";
  eObj["eventAction"] = "Launch";

  setEvents(
    "amplitude",
    "coupon_application_success",
    getAmplitudeEventObj(eObj)
  );
};
const EVENT_DIALOGUE_LAUNCHED = (eObj = {}) => {
  eObj["eventCategory"] = "Dialogue";

  setEvents("amplitude", "Dialogue", getAmplitudeEventObj(eObj));
};
const EVENT_DIALOGUE_CTA_CLICK = (eObj = {}) => {
  setEvents("amplitude", "Dialogue_Action", getAmplitudeEventObj(eObj));
};

const EVENT_LOCATION_CLICK = (eObj = {}) => {
  eObj["userAction"] = "click";
  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
};

const EVENT_ORDER_DETAILS_PAGE_CLICK = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "Order Details page";
  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
};

const EVENT_ORDER_DETAILS_PAGE_IMPRESSION = (eObj = {}) => {
  eObj["userAction"] = "impression";
  eObj["sectionName"] = "Order Details page";
  setEvents("amplitude", "Impression", getAmplitudeEventObj(eObj));
};

const EVENT_EXPLORE_MENU_CATEGORY_CLICK = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "explore menu";
  eObj["sectionPosition"] = "5";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
};

const EVENT_BEGIN_CHECKOUT = (eObj = {}) => {
  eObj["eventCategory"] = "Ecommerce";
  eObj["eventAction"] = "Checkout";
  eObj["checkoutOption"] = "Place Order";
  eObj["checkoutStep"] = "1";
  eObj["checkoutStage"] = "checkout initiated";
  //   Event Label=<>,Item Name : [Chicken Pizza, Chicken Calzon, Garlic Bread],
  //   Item SKU (as a 1D array)=<>,
  // Ecom Category (as an array): [Pizza, Sides, Sides], Quantity (as an array): [1,1,2], Price (as an array)=<>,

  //  Payment Method Saved=<yes/no>, Payment Method=<>, Address Saved=<yes/no>, Address=<>

  setEvents("amplitude", "begin_checkout", getAmplitudeEventObj(eObj));
  setEvents("meta", "FB_InitiateCheckout", {});
};

const EVENT_CHECKOUT_PROGRESS = (eObj = {}) => {
  eObj["eventCategory"] = "Ecommerce";
  eObj["eventAction"] = "Checkout";
  // checkout_option=Select Address,
  // Item Name = [Chicken Pizza, Chicken Calzon, Garlic Bread],
  // Item SKU (as a 1D array)=<>, Ecom Category (as an array)=[Pizza, Sides, Sides],
  // Quantity (as an array)=[1,1,2], Price (as an array)=<>, Size(as an array)=<>,
  // Crust(as an array)=<>,
  // checkout_step=2,
  // Checkout Stage=checkout initiated,
  // Payment Method Saved=<yes/no>, Payment Method=<>, Address Saved=<yes/no>,
  // Address=<>,
  // Screen Name=<>, Previous Screen Name=<>

  setEvents("amplitude", "checkout_progress", getAmplitudeEventObj(eObj));
};

const EVENT_UNKNOWN_ORDER_STATUS = (eObj = {}) => {
  eObj["eventCategory"] = "Ecommerce";
  eObj["eventAction"] = "Checkout";
  // checkout_option=Select Address,
  // Item Name = [Chicken Pizza, Chicken Calzon, Garlic Bread],
  // Item SKU (as a 1D array)=<>, Ecom Category (as an array)=[Pizza, Sides, Sides],
  // Quantity (as an array)=[1,1,2], Price (as an array)=<>, Size(as an array)=<>,
  // Crust(as an array)=<>,
  // checkout_step=2,
  // Checkout Stage=checkout initiated,
  // Payment Method Saved=<yes/no>, Payment Method=<>, Address Saved=<yes/no>,
  // Address=<>,
  // Screen Name=<>, Previous Screen Name=<>

  setEvents("amplitude", "unknown_order_status", getAmplitudeEventObj(eObj));
};

const EVENT_ORDER_COMPLETED = (eObj = {}) => {
  eObj["eventCategory"] = "Ecommerce";
  eObj["eventAction"] = "Transaction";
  eObj["eventLabel"] = "Success";
  eObj["checkoutStage"] = "order success";
  //Item Name : [Chicken Pizza, Chicken Calzon, Garlic Bread], Item SKU (as a 1D array)=<>, Quantity (as an array): [1,1,2], Total Quantity:=<>, Subtotal (as an array):=<>, Tax=<>, Subtotal pre-discount(as an array)=<>, Delivery Charge=<>, Discount Amount Coupon=<>, Discount Amount Wallet=<>, Carry Bag Charge=<>, Coupon Name=<Coupon Applied on Cart i.e. any coupon or EDV coupon>, Card ID=<>, Order ID=<>, Payment Method Saved=<yes/no>, Payment Method=<>, Address Saved=<yes/no>, Address=<>,

  setEvents("amplitude", "OrderCompleted", getAmplitudeEventObj(eObj));
};

const EVENT_PRODUCT_PURCHASED = (eObj = {}) => {
  eObj["eventCategory"] = "Ecommerce";
  eObj["eventAction"] = "Transaction";
  eObj["eventLabel"] = "Success";
  eObj["checkoutStage"] = "order success";
  //Item Name : [Chicken Pizza, Chicken Calzon, Garlic Bread], Item SKU (as a 1D array)=<>, Quantity (as an array): [1,1,2], Total Quantity:=<>, Subtotal (as an array):=<>, Tax=<>, Subtotal pre-discount(as an array)=<>, Delivery Charge=<>, Discount Amount Coupon=<>, Discount Amount Wallet=<>, Carry Bag Charge=<>, Coupon Name=<Coupon Applied on Cart i.e. any coupon or EDV coupon>, Card ID=<>, Order ID=<>, Payment Method Saved=<yes/no>, Payment Method=<>, Address Saved=<yes/no>, Address=<>,

  setEvents("amplitude", "Product Purchased", getAmplitudeEventObj(eObj));
  setEvents("meta", "FB_Purchase", {});
};

const EVENT_ORDER_FAILED = (eObj = {}) => {
  eObj["eventCategory"] = "Ecommerce";
  eObj["eventAction"] = "Checkout";

  setEvents("amplitude", "faliure_order", getAmplitudeEventObj(eObj));
  setEvents("meta", "FB_Web_Order_Failed", {});
};

const EVENT_ITEM_CUSTOMISE_SHOWN = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "customisable drawer";
  eObj["category"] = "customise drawer shown";
  setEvents("amplitude", "item_customise", getAmplitudeEventObj(eObj));
};
const EVENT_ITEM_CUSTOMISE_OPTION_SELECTED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "customisable drawer";
  eObj["category"] = "customisation selected";

  setEvents("amplitude", "item_customise", getAmplitudeEventObj(eObj));
};

const EVENT_CLICK_ORDER_FILTER = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "My Orders Page";

  setEvents("amplitude", "click", getAmplitudeEventObj(eObj));

  // section_position=<index of the filter>,
  // category=<Filter Selected/Filter Removed>,
  // subcategory=<filter-name>,
};

export {
  setEvents,
  loadAmplitudeUnsentEvents,
  updateAmplitudeUserProperties,
  initializeTimeSpentEvent,
  getAmplitudeEventObj,
  EVENT_PAGEVIEW_HOMEPAGE,
  EVENT_CLICK_SEARCHICON,
  EVENT_PAGEVIEW_SEARCHPAGE,
  EVENT_PAGEVIEW_LOGINPAGE,
  EVENT_PAGEVIEW_OFFERSPAGE,
  EVENT_PAGEVIEW_PROFILEPAGE,
  EVENT_PAGEVIEW_CARTPAGE,
  EVENT_PAGEVIEW_LOCATIONPAGE,
  EVENT_PAGEVIEW_FAVOURITEPAGE,
  EVENT_PAGEVIEW_ORDERHISTORYPAGE,
  EVENT_PAGEVIEW_MENUPAGE,
  EVENT_PAGEVIEW_ADDRESSESPAGE,
  EVENT_PAGEVIEW_CONTENTPAGE,
  EVENT_TYPE_SEARCHINPUT,
  EVENT_IMPRESSION_SEARCHRESULT,
  EVENT_IMPRESSION_PROMOTION,
  EVENT_IMPRESSION_OFFERS,
  EVENT_CLICK_SEARCHOPTION,
  EVENT_CLICK_PROMOTION,
  EVENT_CLICK_ORDERTYPE,
  EVENT_IMPRESSION_INLINENOTIFICATION,
  EVENT_CLICK_INLINENOTIFICATION,
  EVENT_IMPRESSION_UPSELL_ITEM,
  EVENT_CLICK_UPSELL_ITEM,
  EVENT_CLICK_FILTERS,
  EVENT_CLICK_MENU_CATEGORY,
  EVENT_CLICK_ADDRESS,
  EVENT_CLICK_BOTTOM_STICKY_BAR,
  EVENT_CLICK_FAVOURITE_BUTTON,
  EVENT_CLICK_ADDTOCART,
  EVENT_CLICK_REMOVEFROMCART,
  EVENT_CLICK_EDITITEMINCART,
  EVENT_CLICK_VIEWCART,
  EVENT_HAMBURGER_OPENED,
  EVENT_HAMBURGER_CLOSED,
  EVENT_HAMBURGER_LIST_ITEM_CLICKED,
  EVENT_LOGIN_CTA_CLICKED,
  EVENT_LOGOUT_CTA_CLICKED,
  EVENT_CLICK_TRACKORDER,
  EVENT_IMPRESSION_TRACKORDER,
  EVENT_IMPRESSION_CUSTOMIZATION,
  EVENT_CLICK_CUSTOMIZATION,
  EVENT_CLICK_CUSTOMIZATION_COMBO,
  EVENT_TYPE_MOBILENUMBER,
  EVENT_CLICK_LOGIN_SKIP,
  EVENT_CLICK_SENDOTP,
  EVENT_CLICK_CHANGEMOBILENUMBER,
  EVENT_CLICK_RESENDSMS,
  EVENT_TYPE_OTP,
  EVENT_CLICK_SUBMITOTP,
  EVENT_AUTO_LOGIN_TRIGGERED,
  EVENT_CLICK_AUTO_FETCH_MOBILE_NO,
  EVENT_OTP_GENERATION_SUCCESSFUL,
  EVENT_OTP_GENERATION_FAILED,
  EVENT_LOGIN_SUCCESSFUL,
  EVENT_LOGIN_FAILED,
  EVENT_CLICK_VIEW_ALL_PREVIOUS_ORDERS,
  EVENT_CLICK_REORDER,
  EVENT_CLICK_ORDER_DETAIL,
  EVENT_CLICK_HELP_TRACK_ORDER,
  EVENT_CLICK_CALL_TRACK_ORDER,
  EVENT_CLICK_DOWNLOAD_BILL_TRACK_ORDER,
  EVENT_CLICK_VIEW_DETAILED_BILL,
  EVENT_CLICK_OFFER,
  EVENT_CLICK_REMOVE_OFFER,
  EVENT_CLICK_APPLYOFFERSUCCESS,
  EVENT_CLICK_APPLYOFFERFAILURE,
  EVENT_CLICK_OSBACK,
  EVENT_CLICK_PWABACK,
  EVENT_IMPRESSION_RESTAURANT_SELECTION,
  EVENT_IMPRESSION_NO_RESTAURANT_AVAILABLE,
  EVENT_IMPRESSION_NO_DELIVERY_ZONE,
  EVENT_CLICK_RESTAURANT_SELECTION,
  EVENT_CLICK_MAP_OR_LIST_VIEW,
  EVENT_CLICK_BOTTOM_STICKY_MENU,
  EVENT_CLICK_CATEGORY_BOTTOM_STICKY_MENU,
  EVENT_CLICK_OPTIN_POPUP_ADD_NEW,
  EVENT_CLICK_OPTIN_POPUP_REPEAT_LAST,
  EVENT_CLICK_MINICART_ADD,
  EVENT_CLICK_CARTUPSELL_ADD,
  EVENT_CLICK_MINICART_REMOVE,
  EVENT_CLICK_MINICART_UPDATE,
  EVENT_CLICK_COMBO_ADD,
  EVENT_CLICK_COMBO_REMOVE,
  EVENT_IMPRESSION_TIPOPTIONS,
  EVENT_CLICK_TIPOPTIONS_SELECTED,
  EVENT_CLICK_TIPOTHER_SELECTED,
  EVENT_CLICK_TIP_UNSELECTED,
  EVENT_CLICK_TIPENABLEFORFUTURE,
  EVENT_CLICK_TIPDISABLEFORFUTURE,
  EVENT_TIP_ERROR,
  EVENT_CLICK_DELIVERYINSTRUCTION,
  EVENT_CLICK_CARTCHANGEADDRESS,
  EVENT_NEW_ADDRESS_ADDED,
  EVENT_CLICK_ADVANCE_ORDER_MODAL_OPEN,
  EVENT_CLICK_ADVANCE_ORDER_DATE_SELECTED,
  EVENT_CLICK_ADVANCE_ORDER_TIME_SELECTED,
  EVENT_CLICK_DELIVERYTIME_DROPDOWN,
  EVENT_CLICK_INSTANT_DELIVERY,
  EVENT_CLICK_SCHEDULE_DELIVERY,
  EVENT_CLICK_ADVANCE_ORDER_FLOW_DONE,
  EVENT_CLICK_ADVANCE_ORDER_TIMEDIFF,
  EVENT_CLICK_VIEWMORECARTOFFERS,
  EVENT_CLICK_VIEWMORE_OFFER_CARD,
  EVENT_CLICK_APPLYMANUALCOUPONSUCCESS,
  EVENT_CLICK_APPLYMANUALCOUPONFAILURE,
  EVENT_CLICK_CARTSUBMIT,
  EVENT_CLICK_CARTCONTINUE,
  EVENT_CLICK_CART_EXPLOREMENU,
  EVENT_CART_VIEWED,
  EVENT_CART_END,
  EVENT_CLICK_ADD_MORE_ITEMS,
  EVENT_CLICK_COUPONS_TOP_BAR,
  EVENT_CART_CLICK_PLUS_ONE,
  EVENT_CART_CLICK_MINUS_ONE,
  EVENT_CART_CLICK_REMOVE_LAST_ITEM,
  EVENT_CROSS_SELL_CART,
  EVENT_CART_CLICK_CROSS_SELL_PLUS_ONE,
  EVENT_CART_CROSS_SELL_COLLAPSE,
  EVENT_CLICK_OFFER_SELECT,
  EVENT_ADDRESS_STATUS,
  EVENT_ADD_SELECT_ADDRESS,
  EVENT_SET_LOCATION_AND_ADD_ADDRESS,
  EVENT_ADVANCE_ORDER_CLICK,
  EVENT_CART_COUPON,
  EVENT_APPLY_CLICK_CART_COUPON,
  EVENT_COUPON_APPLICATION_SUCCESS_CONFETTI_LAUNCHED,
  EVENT_DIALOGUE_LAUNCHED,
  EVENT_DIALOGUE_CTA_CLICK,
  EVENT_LOCATION_CLICK,
  EVENT_ORDER_DETAILS_PAGE_CLICK,
  EVENT_ORDER_DETAILS_PAGE_IMPRESSION,
  EVENT_EXPLORE_MENU_CATEGORY_CLICK,
  EVENT_BEGIN_CHECKOUT,
  EVENT_CHECKOUT_PROGRESS,
  EVENT_UNKNOWN_ORDER_STATUS,
  EVENT_ORDER_COMPLETED,
  EVENT_PRODUCT_PURCHASED,
  EVENT_ITEM_CUSTOMISE_SHOWN,
  EVENT_ITEM_CUSTOMISE_OPTION_SELECTED,
  EVENT_ORDER_FAILED,
  EVENT_CLICK_ORDER_FILTER,
};
